import { render } from "react-dom";

  const renderLearningPlan = (data) => (
    <div className="learning-plan">
      <div className="plan-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
        <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
          📚 Learning & Improvement Plan
        </h3>
        <p className="text-foreground">{data.analysis}</p>
      </div>

      {data.plan && (
        <div className="plan-content grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="focus-area bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              🎯 Primary Focus
            </h4>
            <p className="text-card-foreground">{data.plan.focus_area}</p>
            <div className="mt-3 text-sm text-muted-foreground">
              Duration: {data.plan.duration}
            </div>
          </div>

          <div className="success-criteria bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              ✅ Success Criteria
            </h4>
            <p className="text-card-foreground">{data.plan.success_criteria}</p>
          </div>

          <div className="daily-actions bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              📅 Daily Actions
            </h4>
            <ul className="space-y-2">
              {data.plan.daily_actions?.map((action, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  <span className="text-card-foreground">{action}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="weekly-goals bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              🗓️ Weekly Goals
            </h4>
            <ul className="space-y-2">
              {data.plan.weekly_goals?.map((goal, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  <span className="text-card-foreground">{goal}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="metrics bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              📊 Track These Metrics
            </h4>
            <ul className="space-y-2">
              {data.plan.metrics_to_track?.map((metric, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-accent mr-2">•</span>
                  <span className="text-card-foreground">{metric}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="resources bg-card p-6 rounded-lg border border-border shadow-sm">
            <h4 className="text-lg font-semibold text-foreground mb-3 flex items-center">
              📖 Resources
            </h4>
            <ul className="space-y-2">
              {data.plan.resources?.map((resource, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-accent mr-2">•</span>
                  <span className="text-card-foreground">{resource}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );

  export default renderLearningPlan;